import { Tooltip } from 'bootstrap'

const initializeTooltips = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
    Tooltip.getOrCreateInstance(element)
  })
}

export { initializeTooltips }
